import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types.ts'
import { Paper } from 'shared/ui/paper'

import s from './styles.module.scss'

export const PrepaymentInfo = () => {
  const { t } = useTranslation()
  return (
    <Paper
      className={s.container}
      padding={[12, 16, 12, 16]}
    >
      <div className={s.box}>
        <AppIcon
          id={AllIcons.MONEY}
          width={24}
          height={24}
          className={s.icon}
        />

        <div className={s.info}>
          <p className={clsx('semi-bold-14', s.title)}>
            {t('umrah_block.advance_title')}
          </p>
          <p className={clsx('medium-13', s.subtitle)}>
            {t('umrah_block.advance_subtitle')}
          </p>
        </div>
      </div>

      <div className={s.divider} />

      <div className={s.box}>
        <AppIcon
          id={AllIcons.PHONE}
          width={24}
          height={24}
          className={s.icon}
        />

        <div className={s.info}>
          <p className={clsx('semi-bold-14', s.title)}>
            {t('umrah_block.connect_title')}
          </p>
          <p className={clsx('medium-13', s.subtitle)}>
            {t('umrah_block.connect_subtitle')}
          </p>
        </div>
      </div>
    </Paper>
  )
}
